module.exports = __webpack_public_path__ + "front/img/c16.329248cb.png";